import { billingService } from '@/services/BillingService';

const state = () => ({
  billingPeriods: [],
});

const mutations = {
  setBillingPeriods(state: any, data: any) {
    state.billingPeriods = data;
  },
};

const actions = {
  getBillingPeriods({ commit, state, rootState }: any) {
    return new Promise(resolve => {
      billingService
        .getBillingPeriods(rootState.currentWorkspace.id)
        .then((data: any) => {
          commit('setBillingPeriods', data);
          resolve(data);
        })
        .catch(() => {
          resolve(state.billingPeriods);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
